import { render } from "./posheduleEdit.vue?vue&type=template&id=2f765f9e"
import script from "./posheduleEdit.vue?vue&type=script&lang=js"
export * from "./posheduleEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__